import React from 'react';
import FullLogo, { FullLogoPride } from './components/full-logo';
import HLogo from './components/h-logo';
import ChristmasLogo from './components/christmas-logo';
import { TwentyFiveYearsLogo } from './components/25-years-logo';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesLogo = _ref => {
  var _ref$logoType = _ref.logoType,
    logoType = _ref$logoType === void 0 ? 'full' : _ref$logoType,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'color' : _ref$variant;
  if (logoType === 'h') {
    return ___EmotionJSX(HLogo, {
      className: className
    });
  }
  if (variant === 'christmas') {
    return ___EmotionJSX(ChristmasLogo, {
      className: className
    });
  }
  if (variant === '25-years') {
    return ___EmotionJSX(TwentyFiveYearsLogo, {
      className: className
    });
  }
  return ['pride', 'mardi-gras'].includes(variant) ? ___EmotionJSX(FullLogoPride, {
    className: className
  }) : ___EmotionJSX(FullLogo, {
    colorScheme: variant,
    className: className
  });
};
export default AllhomesLogo;